import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../redux/items/types"
import ChargeCard from "./ChargeCard"

class DetailCharge extends React.Component {

  componentDidMount() {
    const { params, setCurrentChargeId, loadCharges, charge } = this.props
    setCurrentChargeId(params.id)
    if(!charge) {
      loadCharges()
    }
  }

  render() {
    const { charge } = this.props;
    return charge ? <ChargeCard charge={ charge } /> : <p>Loading ..</p>
  }
}

DetailCharge.propTypes = {
  charge: PropTypes.object,
  setCurrentChargeId: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {
  const charge = DckSelectors.selectItemById(state, ItemTypes.Charges, ownProps.params.id);
  return { charge }
}

const mapDispatchToProps = dispatch => ({
  setCurrentChargeId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.Charges, id)),
  loadCharges: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Charges)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DetailCharge)



// WEBPACK FOOTER //
// ./src/components/Charges/DetailCharge.js